<app-select-filter-data
        [filterElementProcessor]="filter"
        [findAllService]="findAllService"
        [parentFormControlName]="parentFormControlName"
        [parentFormGroup]="parentFormGroup"
        [resolveSelectFilterElement]="resolveSelectFilterElement">
  <ng-template let-element='element' template-content>
    {{element.formDefinition.label}}
  </ng-template>
</app-select-filter-data>
